export default {
    announcements: 'Announcements',
    announcementsDescription: 'Roughly 1-2 emails a month.',
    editNotificationSettings: 'Edit Notification Settings',
    iMy: 'I../My..',
    manageEmails: 'Manage Emails',
    myTeam: "My team../My Team's..",
    onboarding: 'Onboarding, Tips, Tricks',
    onboardingDescription:
        'We occasionally send you a few emails to help you get the most out of MakeLeaps.',
    subtitleAccountActivityNotifications: 'Account Activity Notifications',
    subtitleProductNotifications: 'Product Notifications',
    systemNotifications: 'System Notifications',
    systemNotificationsDescription:
        'Important notifications such as password resets.',
    title: 'Notification Settings',
    userNotifications: 'User Notifications',
};
